import { Injectable } from '@angular/core';
import { ApplicationInsights, IExceptionTelemetry } from '@microsoft/applicationinsights-web';
import { AppConfig } from '@shared/utils/app-config';

@Injectable()
export class ApplicationInsightsService {
  appInsights: ApplicationInsights;

  constructor(appConfig: AppConfig) {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: appConfig.applicationInsights.instrumentationKey,
      },
    });

    if (appConfig.production) {
      this.appInsights.loadAppInsights();
    }
  }

  trackException(exception: Error, properties?: { [key: string]: unknown }): void {
    const telemetry: IExceptionTelemetry = { exception, properties };
    this.appInsights.trackException(telemetry);
  }
}
